<app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>

<div class="grid grid-cols-1 gap-6">
  <app-component-card [title]="pageTitle" desc="Complete los datos de la regla de ciclo de lead">

    <!-- Loading -->
    @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando datos...</span>
    </div>
    }

    <!-- Error -->
    @if (error) {
    <div class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
    }

    <!-- Duplicate Order Error -->
    @if (duplicateOrderError) {
    <div class="mb-4 p-4 bg-warning-50 border border-warning-200 rounded-lg dark:bg-warning-500/10 dark:border-warning-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-warning-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
        <p class="text-warning-600 dark:text-warning-400">{{ duplicateOrderError }}</p>
      </div>
    </div>
    }

    <!-- Formulario -->
    @if (!loading) {
    <form (ngSubmit)="guardar()" #ruleForm="ngForm" class="space-y-5">

      <!-- Ciclo y Atributo -->
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">

        <!-- Ciclo de Lead -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Ciclo de Lead <span class="text-error-500">*</span>
          </label>
          <select
            name="idLeadCycle"
            #cycleField="ngModel"
            [(ngModel)]="idLeadCycle"
            required
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed">
            <option [ngValue]="null" disabled>Seleccione un ciclo...</option>
            @for (ciclo of ciclos; track ciclo.id) {
            <option [ngValue]="ciclo.id">{{ ciclo.name }}</option>
            }
          </select>
          @if (ciclos.length === 0) {
          <p class="mt-1 text-xs text-warning-500">No hay ciclos disponibles. Cree un ciclo primero.</p>
          }
          @if (cycleField.invalid && (cycleField.dirty || cycleField.touched)) {
          <p class="mt-1 text-xs text-error-500">Seleccione un ciclo de lead.</p>
          }
        </div>

        <!-- Atributo de Lead -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Atributo de Lead <span class="text-error-500">*</span>
          </label>
          <select
            name="idLeadAttribute"
            #attributeField="ngModel"
            [(ngModel)]="idLeadAttribute"
            required
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed">
            <option [ngValue]="null" disabled>Seleccione un atributo...</option>
            @for (atributo of atributos; track atributo.id) {
            <option [ngValue]="atributo.id">{{ atributo.displayName }}</option>
            }
          </select>
          @if (atributos.length === 0) {
          <p class="mt-1 text-xs text-warning-500">No hay atributos disponibles. Cree un atributo primero.</p>
          }
          @if (attributeField.invalid && (attributeField.dirty || attributeField.touched)) {
          <p class="mt-1 text-xs text-error-500">Seleccione un atributo de lead.</p>
          }
        </div>
      </div>

      <!-- Tipo de Operación -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Tipo de Operación <span class="text-error-500">*</span>
        </label>
        <select
          name="operationType"
          [(ngModel)]="operationType"
          required
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed">
          @for (option of operationTypeOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Define cómo se modificará el atributo al activar el ciclo
        </p>
      </div>

      <!-- Expresión de Valor — etiqueta y placeholder cambian con operationType -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ valueExpressionLabel }} <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          name="valueExpression"
          #valueField="ngModel"
          [(ngModel)]="valueExpression"
          (ngModelChange)="onValueExpressionChange($event)"
          required
          [placeholder]="valueExpressionPlaceholder"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          [class.border-warning-500]="valueExpressionValidationError"
        />
        @if (valueField.invalid && (valueField.dirty || valueField.touched)) {
        <p class="mt-1 text-xs text-error-500">{{ valueExpressionLabel }} es obligatorio.</p>
        }
        @if (valueExpressionValidationError) {
        <p class="mt-1.5 text-sm text-warning-600 dark:text-warning-400 flex items-center gap-1">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          {{ valueExpressionValidationError }}
        </p>
        }
        @if (operationType === 'SET') {
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Valor literal que se asignará al atributo (ej: true, 100, texto_fijo)
        </p>
        }
        @if (operationType === 'INCREMENT') {
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Valor numérico que se sumará al valor actual del atributo (ej: 10, -5)
        </p>
        }
        @if (operationType === 'COPY_FROM_FIELD') {
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Nombre del campo fuente del que se copiará el valor (ej: idLeadState)
        </p>
        }
      </div>

      <!-- Orden de Ejecución y Estado Activo -->
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">

        <!-- Orden de Ejecución -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Orden de Ejecución
          </label>
          <input
            type="number"
            name="executionOrder"
            #orderField="ngModel"
            [(ngModel)]="executionOrder"
            required
            min="1"
            step="1"
            placeholder="1"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Número de orden en que se ejecuta esta regla dentro del ciclo
          </p>
          @if (orderField.invalid && (orderField.dirty || orderField.touched)) {
          <p class="mt-1 text-xs text-error-500">Indique un orden de ejecución mayor o igual a 1.</p>
          }
        </div>

        <!-- Estado Activo -->
        <div class="flex items-start gap-3 pt-6">
          <input
            type="checkbox"
            name="isActive"
            [(ngModel)]="isActive"
            id="isActive"
            class="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800"
          />
          <div>
            <label for="isActive" class="text-sm font-medium text-gray-700 dark:text-gray-300">
              Regla activa
            </label>
            <p class="text-xs text-gray-500 dark:text-gray-400">
              Si está desmarcado, la regla no se ejecutará al activar el ciclo
            </p>
          </div>
        </div>
      </div>

      <!-- Botones -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button
          variant="outline"
          type="button"
          (btnClick)="cancelar()">
          Cancelar
        </app-button>
        <app-button
          variant="primary"
          type="submit"
          [disabled]="saving || checkingDuplicate">
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear Regla') }}
        </app-button>
      </div>
    </form>
    }

  </app-component-card>
</div>
